import { render, staticRenderFns } from "./form-row-single-document-upload.vue?vue&type=template&id=78150b09&scoped=true&"
import script from "./form-row-single-document-upload.vue?vue&type=script&lang=js&"
export * from "./form-row-single-document-upload.vue?vue&type=script&lang=js&"
import style0 from "./form-row-single-document-upload.vue?vue&type=style&index=0&id=78150b09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78150b09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78150b09')) {
      api.createRecord('78150b09', component.options)
    } else {
      api.reload('78150b09', component.options)
    }
    module.hot.accept("./form-row-single-document-upload.vue?vue&type=template&id=78150b09&scoped=true&", function () {
      api.rerender('78150b09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-single-document-upload.vue"
export default component.exports